<template>
    <div class="news_search">
        <Top></Top>
        <div class="container" style="min-height: 852px">
            <nav class="sub-nav">
                <div class="nav_search">
                    <img src="@/assets/img/sousuo.png" @click="searchClick()">
                    <input type="text" :placeholder="$t('m.news.text[0]')" @keyup="search" v-model="search_text">
                </div>
            </nav>
            <div class="page-header">
                <h1>{{ $t('m.news.text[4]') }}</h1>
                <p class="page-header-description">“ {{ name }} ” {{ $t('m.news.text[5]') }}：{{ articleList.length }}{{ $t('m.news.text[6]') }}</p>
            </div>
            <div class="search-results">
                <div class="search-results-column">
                    <h3 class="search-results-subheading">{{ $t('m.news.text[7]') }}</h3>
                    <ul class="search-results-list">
                        <li v-for="(v,k) in articleList" :key="k"
                            class="search-result">
                            <a @click="changeRoute('/news/detail/',{id:v.id,catename:v.catename})"
                                    class="search-result-link">{{ $i18n.locale == 'zh-CN' ? v.title_ch : v.title_en }}</a>
                            <div class="search-result-description" v-html="$i18n.locale == 'zh-CN' ? v.content : v.en_content"></div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <Bottom></Bottom>
    </div>
</template>

<script>
    import Top from '@/components/top'
    import Bottom from '@/components/bottom'

    export default {
        name: "search",
        components: {
            Top, Bottom
        },
        data() {
            return {
                search_text: "",
                name: "",
                request: {
                    hot: 1,
                    pageNo: 1,
                    pageSize: 10,
                    catename: "",
                    catename_en: ""
                },
                articleList: []
            }
        },
        created() {
            this.search_text = this.$route.query.search_text;
            this.name = this.$route.query.search_text;
            this.getData();
        },
        methods: {
            getData: function () {
                this.articleList = [];
                this.request.signature = this.signature(this.request);
                this.$axios.get(this.requestConfig.host + "/index/Article/articleList", {
                    params: this.request
                }).then((res) => {
                    return this.checkResponse(res);
                }).then((res) => {
                    for (let i in res.list) {
                        if (this.$i18n.locale == 'zh-CN') {
                            if (res.list[i].title_ch.indexOf(this.name) > -1) {
                                this.articleList.push(res.list[i]);
                            }
                        } else {
                            if (res.list[i].title_en.toUpperCase().indexOf(this.name.toUpperCase()) > -1) {
                                this.articleList.push(res.list[i]);
                            }
                        }
                    }
                }).catch((e) => {

                })
            },
            search: function () {
                if (this.search_text != ""){
                    let e=window.event||arguments.callee.caller.arguments[0];
                    if(e.keyCode==13){
                        this.name = this.search_text;
                        this.getData();
                    }
                }
            },
            searchClick() {
                if (this.search_text != "") {
                    this.name = this.search_text;
                    this.getData();
                }
            }
        }
    }
</script>

<style scoped>
    .news_search .container {
        padding: 0;
        width: 90%;
        max-width: 1160px;
        margin: 0 auto;
    }

    .sub-nav {
        margin-bottom: 30px;
        min-height: 50px;
        padding-top: 30px;
        padding-bottom: 15px;
    }

    .nav_search {
        float: right;
        position: relative;
    }

    .nav_search img {
        width: 30px;
        height: 30px;
        cursor: pointer;
        position: absolute;
        z-index: 999;
        left: 10px;
        top: 5px;
    }

    .nav_search input {
        border: 1px solid #ddd;
        border-radius: 30px;
        box-sizing: border-box;
        color: #999;
        width: 300px;
        height: 40px;
        padding-left: 40px;
        padding-right: 20px;
        outline: 0;
    }

    .nav_search input:focus {
        border: 1px solid rgba(53, 124, 225, 1);
    }

    .page-header {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: baseline;
        margin: 0;
    }

    .page-header h1 {
        flex-grow: 1;
        margin-bottom: 10px;
        font-size: 32px;
    }

    .page-header-description {
        font-style: italic;
        font-weight: 300;
        margin: 0 0 30px 0;
        word-break: break-word;
        flex-basis: 100%;
        font-size: 15px;
    }

    .search-results {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .search-results-column {
        flex: 0 0 70%;
    }

    .search-results-column h3 {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 15px;
    }

    .search-results-list {
        margin-bottom: 25px;
    }

    .search-results-list > li {
        border-bottom: 1px solid #ddd;
        padding: 20px 0;
        font-size: 15px;
    }

    .search-results-list > li:first-child {
        border-top: 1px solid #ddd;
    }

    .search-results-list > li a {
        cursor: pointer;
    }

    .search-results-list > li a:hover {
        text-decoration: underline;
    }

    .search-result-description {
        margin-top: 15px;
    }
</style>
